import NetworkService from "./NetworkService";

export default class AdminActionLogService extends NetworkService {
  constructor() {
    super();
    this.endpoints.adminActionLogs = "api/admin-action-logs";
    this.endpoints.adminActionLogsFilters = "api/admin-action-logs/filters";
  }

  list(filters = {}) {
    return this.get(this.endpoints.adminActionLogs, filters);
  }

  listFilters() {
    return this.get(this.endpoints.adminActionLogsFilters);
  }
}
